import { render, staticRenderFns } from "./FaqElement.vue?vue&type=template&id=39e39e88&scoped=true"
import script from "./FaqElement.vue?vue&type=script&lang=js"
export * from "./FaqElement.vue?vue&type=script&lang=js"
import style0 from "./FaqElement.vue?vue&type=style&index=0&id=39e39e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e39e88",
  null
  
)

export default component.exports